import { render, staticRenderFns } from "./EventModal.vue?vue&type=template&id=48122b8c&scoped=true"
import script from "./EventModal.vue?vue&type=script&lang=js"
export * from "./EventModal.vue?vue&type=script&lang=js"
import style0 from "./EventModal.vue?vue&type=style&index=0&id=48122b8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48122b8c",
  null
  
)

export default component.exports